var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{staticStyle:{"width":"100%","height":"250px"},attrs:{"center":_vm.center,"zoom":13}},[_c('gmap-marker',{attrs:{"position":_vm.markers,"title":"Dirección de envío","clickable":true,"draggable":true},on:{"click":function($event){_vm.center = _vm.center}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }